<template>
  <div class="footer" v-show="isShow">大倉文庫 版權所有@北京大學出版社</div>
</template>

<script>
export default {
  data () {
    return {
      showDrawer: false,
      list: [{
        path: '/',
        title: '首頁'
      }, {
        path: '/show',
        title: '映像-書影'
      }, {
        path: '/dddd',
        title: '尋蹤-書目'
      }, {
        path: '/analysis',
        title: '文本分析'
      }, {
        path: '/ddddd',
        title: '大仓故事'
      }]
    }
  },
  created: function () {
    this.isShow = this.$route.name != 'WenKu' ? true : false

  },
  methods: {
    showMenu () {
      this.showDrawer = true
    },
    toPath (path) {
      this.$router.push({
        path: path
      })
    }
  }
}
</script>

<style scoped>
.footer {
  width: 100%;
  height: 50px;
  position: fixed;
  bottom: 0;
  left: 0;
  /* z-index: 999999999999; */
  z-index: 9;
  /* margin-top: -4px; */
  border-top: 4px solid #aa1d1f;
  background: url(../../static/home/footer_bg.png) no-repeat;
  background-size: cover;

  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  text-align: center;
  line-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue